import TextVoiceThen from './textVoiceThen/TextVoiceThen.vue';

const IntegrationModals = {
    'ktv-send-text-action': {
        component: TextVoiceThen,
        size: 'fullscreen',
    },
};

export default {
    IntegrationModals,
    ...IntegrationModals,
};
